export const BUILTIN_CONFIGS = [
    {
        id: 'builtin-precision',
        name: 'Recommended Precision',
        isBuiltin: true,
        settings: {
            mouse: {
                sensitivity: 0.8,
                zoom_sensitivity_ratio: 1.0,
                m_rawinput: true,
                cl_crosshair_sniper_width: 1,
                m_yaw: 0.022,
                m_pitch: 0.022,
                dpi: 800,
                aspectRatio: '16:9'
            },
            crosshair: {
                cl_crosshairstyle: 4,
                cl_crosshairsize: 2,
                cl_crosshairthickness: 0.5,
                cl_crosshairgap: -3,
                cl_crosshairalpha: 255,
                cl_crosshaircolor_r: 0,
                cl_crosshaircolor_g: 255,
                cl_crosshaircolor_b: 0,
                cl_crosshairdot: 0,
                cl_crosshair_drawoutline: 1,
                cl_crosshair_outlinethickness: 0.5,
                cl_crosshair_recoil: 0,
                cl_crosshair_t: 0,
                cl_crosshair_friendly_warning: 1
            },
            viewmodel: {
                viewmodel_offset_x: 2.5,
                viewmodel_offset_y: 0,
                viewmodel_offset_z: -1.5,
                viewmodel_fov: 68,
                cl_prefer_lefthanded: 0,
                viewmodel_switchhands_bind: 'mouse5'
            },
            hud: {
                cl_hud_color: 1,
                hud_scaling: 0.9,
                cl_radar_scale: 0.7,
                cl_hud_radar_scale: 1.0,
                cl_radar_always_centered: 1,
                cl_radar_rotate: 1,
                cl_showloadout: 1
            },
            binds: {
                key_forward: 'w',
                key_back: 's',
                key_left: 'a',
                key_right: 'd',
                key_walk: 'shift',
                key_duck: 'ctrl',
                key_jump: 'space',
                key_attack: 'mouse1',
                key_attack2: 'mouse2',
                key_reload: 'r',
                key_use: 'e',
                key_drop: 'g',
                key_inspect: 'f',
                key_lastinv: 'q',
                key_buymenu: 'b',
                key_autobuy: 'f3',
                key_rebuy: 'f4',
                grenade_flash: 'f',
                grenade_smoke: 'c',
                grenade_molotov: 'v',
                grenade_he: 'x',
                key_mic: 'v',
                key_chat: 'y',
                key_chat_team: 'u',
                key_score: 'tab',
                key_console: '`',
                mwheel_jump: 'down'
            },
            _meta: {
                activeModules: ['mouse', 'crosshair', 'viewmodel', 'hud', 'binds']
            }
        }
    },
    {
        id: 'builtin-agile',
        name: 'Recommended Agile',
        isBuiltin: true,
        settings: {
            mouse: {
                sensitivity: 1.5,
                zoom_sensitivity_ratio: 1.0,
                m_rawinput: true,
                cl_crosshair_sniper_width: 1,
                m_yaw: 0.022,
                m_pitch: 0.022,
                dpi: 800,
                aspectRatio: '16:9'
            },
            crosshair: {
                cl_crosshairstyle: 5,
                cl_crosshairsize: 3,
                cl_crosshairthickness: 1,
                cl_crosshairgap: 0,
                cl_crosshairalpha: 200,
                cl_crosshaircolor_r: 255,
                cl_crosshaircolor_g: 255,
                cl_crosshaircolor_b: 0,
                cl_crosshairdot: 0,
                cl_crosshair_drawoutline: 0,
                cl_crosshair_outlinethickness: 1,
                cl_crosshair_recoil: 1,
                cl_crosshair_t: 0,
                cl_crosshair_friendly_warning: 1
            },
            viewmodel: {
                viewmodel_offset_x: 1,
                viewmodel_offset_y: 1,
                viewmodel_offset_z: -1,
                viewmodel_fov: 60,
                cl_prefer_lefthanded: 0,
                viewmodel_switchhands_bind: 'mouse4'
            },
            hud: {
                cl_hud_color: 2,
                hud_scaling: 1.0,
                cl_radar_scale: 0.5,
                cl_hud_radar_scale: 1.1,
                cl_radar_always_centered: 0,
                cl_radar_rotate: 1,
                cl_showloadout: 1
            },
            binds: {
                key_forward: 'w',
                key_back: 's',
                key_left: 'a',
                key_right: 'd',
                key_walk: 'shift',
                key_duck: 'ctrl',
                key_jump: 'mwheeldown',
                key_attack: 'mouse1',
                key_attack2: 'mouse2',
                key_reload: 'r',
                key_use: 'e',
                key_drop: 'g',
                key_inspect: 'f',
                key_lastinv: 'q',
                grenade_flash: '4',
                key_mic: 'mouse5',
                key_score: 'tab',
                key_console: '`',
                jump_throw: true,
                jump_throw_key: 'v',
                mwheel_jump: 'down'
            },
            _meta: {
                activeModules: ['mouse', 'crosshair', 'viewmodel', 'hud', 'binds']
            }
        }
    },
    {
        id: 'builtin-default',
        name: 'Default CS2 Config',
        isBuiltin: true,
        settings: {
            mouse: {
                sensitivity: 1.25,
                zoom_sensitivity_ratio: 1.0,
                m_rawinput: true,
                cl_crosshair_sniper_width: 1,
                m_yaw: 0.022,
                m_pitch: 0.022,
                dpi: 800,
                aspectRatio: '16:9'
            },
            crosshair: {
                cl_crosshairstyle: 4,
                cl_crosshairsize: 5,
                cl_crosshairthickness: 0.5,
                cl_crosshairgap: 0,
                cl_crosshairalpha: 255,
                cl_crosshaircolor_r: 0,
                cl_crosshaircolor_g: 255,
                cl_crosshaircolor_b: 0,
                cl_crosshairdot: 0,
                cl_crosshair_drawoutline: 0,
                cl_crosshair_outlinethickness: 0.5,
                cl_crosshair_recoil: 0,
                cl_crosshair_t: 0,
                cl_crosshair_friendly_warning: 1
            },
            viewmodel: {
                viewmodel_offset_x: 1,
                viewmodel_offset_y: 1,
                viewmodel_offset_z: -1,
                viewmodel_fov: 60,
                cl_prefer_lefthanded: 0
            },
            hud: {
                cl_hud_color: 1,
                hud_scaling: 0.85,
                cl_radar_scale: 0.7,
                cl_hud_radar_scale: 1.0,
                cl_radar_always_centered: 1,
                cl_radar_rotate: 1,
                cl_showloadout: 1
            },
            binds: {
                key_forward: 'w',
                key_back: 's',
                key_left: 'a',
                key_right: 'd',
                key_walk: 'shift',
                key_duck: 'ctrl',
                key_jump: 'space',
                key_attack: 'mouse1',
                key_attack2: 'mouse2',
                key_reload: 'r',
                key_use: 'e',
                key_drop: 'g',
                key_inspect: 'f',
                key_lastinv: 'q',
                key_buymenu: 'b',
                key_autobuy: 'f3',
                key_rebuy: 'f4',
                key_mic: 'k',
                key_chat: 'y',
                key_chat_team: 'u',
                key_score: 'tab',
                key_console: '`',
                mwheel_jump: 'none'
            },
            _meta: {
                activeModules: ['mouse', 'crosshair', 'viewmodel', 'hud', 'binds']
            }
        }
    }
]
